import React, { useContext, useEffect } from 'react'
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import modalContext from '../context/ModalContext';

function Logout() {
    const navigate = useNavigate();
    const [cookie, setCookie] = useCookies(["token"]);
    const {load, setLoad} = useContext(modalContext);
    useEffect(()=>{
        const logoutFunc = async () => {
            setCookie('token', '');
            navigate('/loggedinhome');
          }
          logoutFunc();
    },[]);

  return (
    <div>Loading</div>
  )
}

export default Logout